import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'
import { CmsPriceListPage } from 'types/cms/single-types'

/**
 * Get the price list page from the CMS
 *
 * @param {Language} locale
 * @returns {Promise<CmsPriceListPage | undefined>}
 */
const getPriceListPage = async (locale: Language = Language.DUTCH): Promise<CmsPriceListPage | undefined> => {
  try {
    const {
      data: { data }
    } = await axios.get<CMSApiResponseBody<CmsPriceListPage>>(`${process.env.CMS_API_URL}/pricelist?locale=${locale}`)

    return data
  } catch (_) {
    return undefined
  }
}

export default getPriceListPage
